import React, { useState } from 'react';
import { Mention, MentionsInput } from 'react-mentions';

import MentionSuggestion from './MentionSuggestion';

import styles from './styles.module.less';

const DEBOUNCING_TIME = 275; // in milliseconds
const SAFE_SIZE_PER_SUGGESTION = 70;
const MAX_SUGGESTIONS = 10;

export const TRIGGER = /(?:^|[(\['"<]|\s)(@([^@]*))$/;

const AutoresizeMentionTextarea = props => {
  const [timeoutId, setTimeoutId] = useState(undefined);
  const [suggestionsList, setSugguestionsList] = useState([]);

  const {
    value,
    onChange,
    placeholder,
    fetch,
    textRef,
    onFocus,
    onKeyDown,
    debouncingTime,
  } = props;

  const getUsersList = (query, callback) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    setTimeoutId(
      // @ts-ignore
      setTimeout(async () => {
        setTimeoutId(undefined);

        const inputToTop = textRef.current.getBoundingClientRect().top;
        let limit = Math.ceil(inputToTop / SAFE_SIZE_PER_SUGGESTION);

        limit = Math.min(limit, MAX_SUGGESTIONS);

        const result = await fetch(query, limit);

        setSugguestionsList(result);
        callback(result);
      }, debouncingTime || DEBOUNCING_TIME)
    );

    callback(suggestionsList);
  };

  // Renders the mention in the text input
  const displayTransform = (_id, display) => {
    return `@${display}`;
  };

  // Renders the suggestion list per <li/>
  const renderSuggestion = user => {
    const suggestion = <MentionSuggestion user={user} />;

    if (!textRef) {
      return suggestion;
    }

    const suggestionList = textRef.current.parentElement.nextElementSibling;

    if (!suggestionList) {
      return suggestion;
    }

    const list = suggestionList.firstElementChild;

    if (!list) {
      return suggestion;
    }

    const innerWidth = window.innerWidth;

    // Overwrite CSS here because of lib limitations
    // suggestionList is not accessible by a class and left is dynamically calculated by the lib
    if (innerWidth <= 500) {
      suggestionList.style.left = 0;
      suggestionList.style.top = 0;
      suggestionList.style.width = '100%';
      list.style.width = '100%';
      list.style.minWidth = '100%';
    }

    return suggestion;
  };

  return (
    <MentionsInput
      allowSpaceInQuery={true}
      allowSuggestionsAboveCursor={true}
      className="mentionWrapper"
      classNames={styles}
      inputRef={textRef}
      onChange={onChange}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      singleLine={false}
      value={value}
      placeholder={placeholder}
    >
      <Mention
        appendSpaceOnAdd={true}
        className={styles.mention}
        data={getUsersList}
        displayTransform={displayTransform}
        markup={'@[__display__](__id__)'}
        renderSuggestion={renderSuggestion}
        trigger={TRIGGER}
      />
    </MentionsInput>
  );
};

export default AutoresizeMentionTextarea;
